"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.chunkArray = chunkArray;
exports.sortArrayOfObjects = sortArrayOfObjects;
/**
 * Chunks an array into chunks of the same size.
 * Given an array of length 7 with a chunkSize setting of 3, this method
 * will return an array with 3 arrays, each containing 3,3 and 1 items.
 *
 * @param array
 * @param chunkSize
 * @returns {Array}
 */
function chunkArray(array, chunkSize) {
    var chunked = [];
    while (array.length > 0) {
        chunked.push(array.splice(0, chunkSize));
    }
    return chunked;
}

/**
 * Sorts the given array of objects according to the given sorting specification.
 * The first argument is the array of objects, the second argument is the property to sort by.
 * The third argument may be set to `true`, if the array should be sorted in a descending fashion.
 *
 * @template T
 * @param {T[]} array
 * @param {string} sortBy
 * @param {boolean} descending
 * @returns {T[]}
 */
function sortArrayOfObjects(array, sortBy) {
    var descending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    return array.sort(function (a, b) {
        var left = a[sortBy] || 0;
        var right = b[sortBy] || 0;
        if (left > right) {
            return descending ? -1 : 1;
        } else if (right > left) {
            return descending ? 1 : -1;
        } else {
            return 0;
        }
    });
}